import React from "react";
import { Create, SimpleForm, TextInput, useNotify, useRedirect } from "react-admin";

import useValidators from "../../hooks/useValidators";

export const CreateComponent: React.FC = () => {
  const { text, email } = useValidators();
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Admin created successfully`, { type: "success" });
    redirect("list", "admins");
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  return (
    <Create mutationOptions={{ onSuccess, onError }}>
      <SimpleForm mode="onBlur" reValidateMode="onBlur">
        <TextInput label="Name" source="name" validate={text} />
        <TextInput label="Email" source="email" validate={email} />
      </SimpleForm>
    </Create>
  );
};
